import React from 'react';
import classNames from 'classnames';

interface INewUserInputProps {
    name: string; // Element name, also used as the ID and for label association
    value: string; // The text value for the element
    label: string; // Text for the input label
    children?: JSX.Element; // Any child elements needed to be placed after the input
    placeholder?: string; // Placeholder text
    handleChange: (value: string) => void; // Handle when the user types in the input
    validationError?: boolean; // Show a red border around the element
    classes?: string; // Additional classes to be added to the element
}

/**
 * Standardised input component to be used in the 'new user' flow
 */
const NewUserInput = ({
    name,
    value,
    label,
    classes,
    children,
    placeholder,
    handleChange,
    validationError,
}: INewUserInputProps): JSX.Element => (
    <div className={`new-user-view-form-group ${classes}`}>
        <label htmlFor={name}>{label}</label>
        <input
            id={name}
            name={name}
            className={classNames({ error: validationError })}
            placeholder={placeholder}
            value={value}
            onChange={evt => handleChange(evt.target.value)}
            onKeyDown={() => false}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            type="text"
        />

        {children}
    </div>
);

export default NewUserInput;
